import React from 'react'
import './style.scss'
import {
  Text
} from '@sitecore-jss/sitecore-jss-react'
import useQueryParams from '../../../../hooks/use-query-params.effect'
import { QueryParamsConst } from '../../../../constants/query-params.constants'
import { useTranslation } from "react-i18next";

const SearchFilterDropdown = ({
  dataVal,
  labelVal,
  defaultVal,
  setUpdateVal
}) => {
  const [page, setPage] = useQueryParams(QueryParamsConst.PAGE, '1')
  var options = dataVal?.map((x, index) => (
    <option key={index} value={x.Key}>
      {x.Value}
    </option>
  ))
  const filterChange = (e) => {
    setUpdateVal(e.target.value)
    setPage('1')
    window?.location?.reload()
  }
  const { t } = useTranslation();

  return (
    <>
      {
        <>
          <Text
            field={{ value: labelVal }}
            tag="span"
            className="filter_text"
          />
          <div className="filter_selection">
            <select value={defaultVal} onChange={filterChange}>
              {options}
            </select>
          </div>
        </>
      }
    </>
  )
}

export default SearchFilterDropdown
